import reqInstance from './encipherRequest'
/*
* H5充值钻石列表
* */
export function getDiamond() {
  let url = '/pay/info/recharge'
  let params = {
    osSource :'3'
  }
  return reqInstance({
    url: url,
    method: 'post',
    data: params
  })
}

/**
 * 验证码登录
 */
export function smsCodeLogin(params) {
  return reqInstance ({
    url: '/auth/h5SmsCodeLogin',
    method: 'post',
    data: params
  })
}

/**
 * 发送短信验证码
 */
export function getSmsCode(params) {
  return reqInstance ({
    url: '/auth/sendSmsCode',
    method: 'post',
    data: params
  })
}
/**
 * 获取openid
 */
export function getOpenid(params) {
  return reqInstance ({
    url: '/account/check/code',
    method: 'post',
    data: params
  })
}
/**
 * 用户信息openid校验
 */
export function checkUser(params) {
  return reqInstance ({
    url: '/account/check/user',
    method: 'post',
    data: params
  })
}
/**
 * 获取用户信息
 */
export function getUserInfo(params) {
  return reqInstance ({
    url: '/account/getUserInfoById',
    method: 'post',
    data: params
  })
}

/**
* 记录充值流水
*
* @param wechatOrderDTO 充值参数
* @return Result
* @see Result 
* @see WechatOrderDTO
*/

export function createdRecord(params) {
  return reqInstance ({
    url: '/account/record/order',
    method: 'post',
    data: params
  })
}

/**
 * 充值
 */

export function payDiamond(params){
  return reqInstance ({
    url: '/wallet/create',
    method: 'post',
    data: params
  })
}

/**
 * 切换用户
 */
  
export function loginOut(params) {
  return reqInstance ({
    url: '/auth/logout',
    method: 'post',
    data: params
  })
}
